export function removeParam(qs: string, param: string) {
  return qs
    .split('&')
    .filter(
      (queryParam) =>
        !(queryParam === param || queryParam.startsWith(`${param}=`)),
    )
    .join('&');
}
